// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"demarcation-m__wrapper__ej4o_"};